/**
 * The RMS threshold below which a microphone signal counts as "quiet" rather than "someone is
 * speaking." Shared so this number cannot drift into two independently-tuned copies — CLAUDE.md's
 * running "one definition, not two" theme (MessagePack casing, the node catalogue).
 *
 * Originally lived on `assistant/SilenceDetector.ts`'s `DEFAULT_SILENCE_TIMER_OPTIONS`, which
 * used the same number for two different jobs: deciding what "quiet" means, and deciding when
 * that quiet should auto-close an open assistant turn. The second job is gone — push-to-talk
 * (plan/ai-in-room.md, "push to talk is more natural... instead of a toggle before and after
 * speaking") replaced silence-based closing with a plain, deterministic button release, so
 * `SilenceDetector`/`SilenceTimer` were deleted outright rather than kept in place unused. The
 * first job survives: `VisorVisualizer` still needs to know what "quiet" means for a peer's own
 * voice display, so the number moves here, next to `VoiceBands.ts` — the module that actually
 * samples a live microphone's RMS today — rather than staying under `assistant/` for a class
 * that no longer exists there.
 */
export const MIC_QUIET_RMS = 0.02;
